import { setElementVisibility } from "./dom.js";

export function hideLayer(mapContainerId, map, id) {
  changeLayerVisibility(mapContainerId, map, id, false);
  changeLayerVisibility(mapContainerId, map, id + 'fill', false);
}

export function showLayer(mapContainerId, map, id) {
  changeLayerVisibility(mapContainerId, map, id, true);
  changeLayerVisibility(mapContainerId, map, id + 'fill', true);
}

export function changeLayerVisibility(mapContainerId, map, id, toVisible) {
  if (map.getSource(id) && map.isSourceLoaded(id)) {
    const visibility = map.getLayoutProperty(id, 'visibility');
    setElementVisibility('#' + mapContainerId + ' .lds-spinner', true);

    if (visibility) {
      if (visibility === 'visible' && toVisible == false) {
        map.setLayoutProperty(id, 'visibility', 'none');
      } else if (visibility !== 'visible' && toVisible == true) {
        map.setLayoutProperty(id, 'visibility', 'visible');
      }
    } else {
      map.setLayoutProperty(id, 'visibility', (toVisible ? 'visible' : 'none'));
    }
  }
}
